import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import Link from 'next/link';


export default function NotFound() {
  const { t } = useTranslation();

  return (
    <section className="page_404 box-card-area">
      <Head>
        <title>{t('commons.error_404')}</title>
      </Head>
      <div className="d-flex">
        <div className="m-auto w-100">
          <div className="text-center">
            <div className="four_zero_four_bg">
              <h1 className="text-center ">404</h1>
            </div>

            <div className="contant_box_404">
              <h3 className="h2">
                {t('commons.warning_404')}
              </h3>

              <Link className="link_404" href="/">
                {t('commons.go_home')}
              </Link>
            </div>
          </div>
        </div>
        <div className='rounded shadow-lg'>
          <RightContent />
        </div>
      </div>
      <style jsx global>{`
        .page_404 {
          background: #fff;
          height: 100%;
          font-family: "Roboto", sans-serif;
        }
        .page_404 .four_zero_four_bg {
          background-image: url("/images/commons/gif/404.gif");
          height: 600px;
          background-position: center;
        }
        .page_404 .four_zero_four_bg h1 {
          font-size: 80px;
        }
        .page_404 .four_zero_four_bg h3 {
          font-size: 80px;
        }
        .page_404 .link_404 {
          color: #fff !important;
          padding: 10px 20px;
          background: #39ac31;
          margin: 20px 0;
          display: inline-block;
        }
        .page_404 .contant_box_404 {
          margin-top: -50px;
        }
      `}</style>
    </section>
  )
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['common']),
  },
})
